import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/endurance-challenge/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/endurance-challenge',
  name: 'activity_endurance_challenge',
  component: Index,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '7日耐力挑战赛',
  },
}

export default [indexRoute]
